import React from "react";
import Box from "onnit-ui/lib/box/Box";
import CartInterface from "../../../interfaces/cart/Cart";
import CartProductListMutable from "./product/CartProductListMutable";
import CartTotalList from "./total/CartTotalList";
import CartProductListImmutable from "./product/CartProductListImmutable";
import CouponInputContainer from "../coupon/CouponInputContainer";
import FreeGiftsContainer from "./product/free-gifts/FreeGiftsContainer";

interface Props {
    cart: CartInterface;
    canMutateProducts?: boolean;
    canAddCoupons?: boolean;
    canRemoveCoupons?: boolean;
    showFreeGifts?: boolean;
    showProductWarningSymbols?: boolean;
}

const Cart = (props: Props) => {
    const {
        cart,
        canMutateProducts = true,
        canAddCoupons = true,
        canRemoveCoupons = true,
        showFreeGifts = true,
        showProductWarningSymbols = false,
    } = props;

    return (
        <Box>
            <Box>
                {showFreeGifts && (
                    <FreeGiftsContainer cart={cart} canAddProducts={canMutateProducts} />
                )}
                {canMutateProducts ? (
                    <CartProductListMutable cart={cart} />
                ) : (
                    <CartProductListImmutable cart={cart} showProductWarningSymbols={showProductWarningSymbols} />
                )}

                {canAddCoupons && (
                    <Box py={5} borderBottom="1px solid" borderColor="grays.1">
                        <CouponInputContainer cart={cart} />
                    </Box>
                )}

                <CartTotalList cart={cart} canRemoveCoupons={canRemoveCoupons} />
            </Box>
        </Box>
    );
};

export default Cart;
